export * as formLabelStyleConfigs from './style-configs';
export { FormLabel } from './form-label';
